import { Component, OnInit } from '@angular/core'

@Component({
    selector: './specifications',
    templateUrl: './specifications.component.html',
    styleUrls: ['../../../../../help.component.css']
})

export class SpecificationsComponent implements OnInit {

    ngOnInit() {

    }
}